import React, { useState } from "react";
import { NavLink } from "react-router-dom";

const cardStyle = {
  background: "#ffffff",
  borderRadius: "8px",
  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
  padding: "20px",
  marginBottom: "20px",
};

const teal = "#06d1c6";
const inputStyle = {
  width: "100%",
  padding: "8px 12px",
  border: "1px solid #e2e8f0",
  borderRadius: "6px",
  backgroundColor: "#fff",
  color: "#334155",
  fontSize: "14px",
};

const TABLE_COLUMNS = [
  "Name of Campaign",
  "Frequency",
  "Template",
  "Purpose",
  "Subject",
  "Recipients",
  "Start Date",
  "Scheduled Time",
  "Last Execution Date",
  "Next Execution Date",
  "Created At",
  "Actions",
];

export default function AdminEmailScheduler() {
  const [activeTab, setActiveTab] = useState("campaigns"); // "campaigns" | "templates"
  const [search, setSearch] = useState("");
  const [frequency, setFrequency] = useState("");
  const [chooseValue, setChooseValue] = useState("");
  const [activeCampaignOnly, setActiveCampaignOnly] = useState(true); // true = Active Campaign, false = Inactive

  const campaigns = []; // No data - empty state

  return (
    <div className="main-content">
      <div className="page-wrapper page-settings">
        <div className="content">
          {/* Breadcrumb and Header with Create Campaign button */}
          <div className="mb-4" style={cardStyle}>
            <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
              <div>
                <div className="content-page-header content-page-headersplit">
                  <h5>Email Scheduler</h5>
                </div>
                <nav aria-label="breadcrumb" style={{ "--bs-breadcrumb-divider": "none", marginBottom: 0 }}>
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <NavLink to="/dashboard">Dashboard</NavLink> /
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Email Scheduler
                    </li>
                  </ol>
                </nav>
              </div>
              <button
                type="button"
                style={{
                  background: teal,
                  color: "#fff",
                  border: "none",
                  padding: "10px 20px",
                  borderRadius: "6px",
                  fontWeight: 600,
                  fontSize: "14px",
                  cursor: "pointer",
                }}
              >
                Create Campaign
              </button>
            </div>
          </div>

          {/* Tabs */}
          <div style={cardStyle}>
            <div className="d-flex flex-wrap align-items-center gap-3 mb-3">
              <div className="d-flex">
                <button
                  type="button"
                  onClick={() => setActiveTab("campaigns")}
                  className="border-0 bg-transparent pb-2 px-0 me-4"
                  style={{
                    fontWeight: 600,
                    fontSize: "15px",
                    color: activeTab === "campaigns" ? teal : "#94a3b8",
                    borderBottom: activeTab === "campaigns" ? `3px solid ${teal}` : "3px solid transparent",
                    cursor: "pointer",
                  }}
                >
                  Campaigns
                </button>
                <button
                  type="button"
                  onClick={() => setActiveTab("templates")}
                  className="border-0 bg-transparent pb-2 px-0"
                  style={{
                    fontWeight: 600,
                    fontSize: "15px",
                    color: activeTab === "templates" ? teal : "#94a3b8",
                    borderBottom: activeTab === "templates" ? `3px solid ${teal}` : "3px solid transparent",
                    cursor: "pointer",
                  }}
                >
                  Templates
                </button>
              </div>
            </div>

            {/* Filters - show when Campaigns tab active */}
            {activeTab === "campaigns" && (
              <div className="d-flex flex-wrap align-items-center gap-3 mb-3">
                <div style={{ minWidth: 180, flex: "1 1 180px" }}>
                  <label className="form-label small text-secondary mb-1 d-block">Search</label>
                  <input
                    type="text"
                    placeholder="Search"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    style={inputStyle}
                  />
                </div>
                <div style={{ minWidth: 140 }}>
                  <label className="form-label small text-secondary mb-1 d-block">Frequency</label>
                  <div className="d-flex align-items-center">
                    <span
                      className="d-flex align-items-center justify-content-center rounded-start"
                      style={{
                        padding: "8px 10px",
                        border: "1px solid #e2e8f0",
                        borderRight: "none",
                        backgroundColor: "#fff",
                        color: "#64748b",
                      }}
                    >
                      <i className="fa-solid fa-filter" style={{ fontSize: "12px" }} />
                    </span>
                    <select
                      value={frequency}
                      onChange={(e) => setFrequency(e.target.value)}
                      style={{
                        ...inputStyle,
                        borderTopLeftRadius: 0,
                        borderBottomLeftRadius: 0,
                        flex: 1,
                      }}
                    >
                      <option value="">Select</option>
                    </select>
                  </div>
                </div>
                <div style={{ minWidth: 140 }}>
                  <label className="form-label small text-secondary mb-1 d-block">Choose Value</label>
                  <div className="d-flex align-items-center">
                    <span
                      className="d-flex align-items-center justify-content-center rounded-start"
                      style={{
                        padding: "8px 10px",
                        border: "1px solid #e2e8f0",
                        borderRight: "none",
                        backgroundColor: "#fff",
                        color: "#64748b",
                      }}
                    >
                      <i className="fa-solid fa-filter" style={{ fontSize: "12px" }} />
                    </span>
                    <select
                      value={chooseValue}
                      onChange={(e) => setChooseValue(e.target.value)}
                      style={{
                        ...inputStyle,
                        borderTopLeftRadius: 0,
                        borderBottomLeftRadius: 0,
                        flex: 1,
                      }}
                    >
                      <option value="">Select</option>
                    </select>
                  </div>
                </div>
                <div className="d-flex align-items-end gap-2 ms-auto">
                  <span className="small text-secondary">Active Campaign</span>
                  <div
                    role="switch"
                    aria-checked={activeCampaignOnly}
                    tabIndex={0}
                    onClick={() => setActiveCampaignOnly((v) => !v)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        setActiveCampaignOnly((v) => !v);
                      }
                    }}
                    style={{
                      width: 48,
                      height: 26,
                      borderRadius: 13,
                      background: activeCampaignOnly ? teal : "#cbd5e1",
                      cursor: "pointer",
                      position: "relative",
                      transition: "background 0.2s",
                    }}
                  >
                    <span
                      style={{
                        position: "absolute",
                        top: 2,
                        left: activeCampaignOnly ? 24 : 2,
                        width: 22,
                        height: 22,
                        borderRadius: "50%",
                        background: "#fff",
                        boxShadow: "0 1px 3px rgba(0,0,0,0.2)",
                        transition: "left 0.2s",
                      }}
                    />
                  </div>
                  <span className="small text-secondary">Inactive Campaign</span>
                </div>
              </div>
            )}

            {/* Table - Campaigns tab */}
            {activeTab === "campaigns" && (
              <div style={{ overflowX: "auto" }}>
                <table className="table table-bordered mb-0" style={{ fontSize: "13px" }}>
                  <thead>
                    <tr style={{ backgroundColor: "#f8fafc" }}>
                      {TABLE_COLUMNS.map((label) => (
                        <th
                          key={label}
                          className="text-nowrap"
                          style={{
                            padding: "10px 12px",
                            fontWeight: 600,
                            color: "#334155",
                          }}
                        >
                          {label}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {campaigns.length === 0 ? (
                      <tr>
                        <td colSpan={TABLE_COLUMNS.length} style={{ padding: "48px 24px", verticalAlign: "middle" }}>
                          <div className="text-center">
                            <div className="mb-2">
                              <i className="fa-solid fa-triangle-exclamation" style={{ fontSize: "42px", color: "#f59e0b" }} aria-hidden />
                            </div>
                            <div style={{ fontWeight: 600, color: "#334155" }}>No data available.</div>
                          </div>
                        </td>
                      </tr>
                    ) : (
                      campaigns.map((row) => (
                        <tr key={row.id}>
                          <td style={{ padding: "10px 12px" }}>{row.name}</td>
                          <td style={{ padding: "10px 12px" }}>{row.frequency}</td>
                          <td style={{ padding: "10px 12px" }}>{row.template}</td>
                          <td style={{ padding: "10px 12px" }}>{row.purpose}</td>
                          <td style={{ padding: "10px 12px" }}>{row.subject}</td>
                          <td style={{ padding: "10px 12px" }}>{row.recipients}</td>
                          <td style={{ padding: "10px 12px" }}>{row.startDate}</td>
                          <td style={{ padding: "10px 12px" }}>{row.scheduledTime}</td>
                          <td style={{ padding: "10px 12px" }}>{row.lastExecutionDate}</td>
                          <td style={{ padding: "10px 12px" }}>{row.nextExecutionDate}</td>
                          <td style={{ padding: "10px 12px" }}>{row.createdAt}</td>
                          <td style={{ padding: "10px 12px" }}>
                            <button type="button" className="btn btn-link p-0 text-secondary" aria-label="Actions">
                              <i className="fa fa-ellipsis-v" />
                            </button>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            )}

            {/* Templates tab content - placeholder */}
            {activeTab === "templates" && (
              <div style={{ padding: "32px 0", textAlign: "center", color: "#64748b" }}>
                <p className="mb-0">Templates content can be added here.</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
